import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import './index.css';
import {
  StylesProvider,
  ThemeProvider,
  createMuiTheme,
} from '@material-ui/core/styles';
import { SnackbarProvider } from 'notistack';
import { AuthorizationProvider } from './components';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { PopupManager } from './providers';
import PlantAndLinesStore from './providers/PlantAndLinesStore/PlantAndLinesStore';
import AppWithErrorBoundary from './components/AppWithErrorBoundary/AppWithErrorBoundary';
import store from './redux';

const theme = createMuiTheme({
  typography: {
    fontFamily: ['Open Sans', 'sans-serif'].join(','),
  },
});

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <StylesProvider injectFirst>
        <Provider store={store}>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <SnackbarProvider maxSnack={3}>
              <PopupManager>
                <AuthorizationProvider>
                  <PlantAndLinesStore>
                    <AppWithErrorBoundary />
                  </PlantAndLinesStore>
                </AuthorizationProvider>
              </PopupManager>
            </SnackbarProvider>
          </MuiPickersUtilsProvider>
        </Provider>
      </StylesProvider>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);
